import { createAction, props } from '@ngrx/store';
import { Group } from '@shared/models/group';

export const batchUpdateCustomers = createAction(
  '[Customers] Batch Update Customers',
  props<{ group: Partial<Group> }>(),
);

export const batchUpdateCustomersSuccess = createAction('[Customers] Batch Update Customers Success');

export const batchUpdateCustomersFailure = createAction(
  '[Customers] Batch Update Customers Failure',
  props<{ error: any }>(),
);
